import React from 'react';
import classNames from 'classnames';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { translate } from 'react-i18next';
import { isMobileOnly } from "react-device-detect";
import MobileLayout from './MobileLayout'
import themeMod from './../../styles/theme/MUItheme'
import IdleTimerWrapper from '../Login/IdleTimer'

const drawerHeight = 65;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginTop: 0,
        width: "100%",
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginTop: drawerHeight,
    },
});
class PersistentDrawerLeft extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
        };
    }

    handleDrawerOpen = () => {
        this.setState({ open: !this.state.open });
    }

    componentDidMount() {
        if (!isMobileOnly) {
            document.body.style.backgroundColor = 'white'
        }
    }

    render() {
        const { classes } = this.props;
        let username = sessionStorage.getItem('username') || '';
        let component = (<></>);

        if (isMobileOnly) {
            component = <MobileLayout username={username}> {this.props.component} </MobileLayout>
        }
        else {
            component = (<div className={classes.root}>
                <CssBaseline />
                <main
                    open={this.state.open}
                    className={classNames(classes.content, {
                        [classes.contentShift]: this.state.open,
                    })}>
                    {this.props.component}
                </main>
            </div>
            )
        }

        return (
            <MuiThemeProvider theme={themeMod}>
                <IdleTimerWrapper
                    refreshTime={this.props.refreshTime}
                    redirectLogin={this.props.redirectLogin}
                    refreshSession={this.props.refreshSession}
                />
                {/* <LogoutWarning /> */}
                {component}
            </MuiThemeProvider>
        )
    }
}

export default translate('common')(withStyles(styles)(PersistentDrawerLeft));